import request from './request'
import store from '@/store'

/**
 * 心跳管理器
 * 确保用户在任何页面都会发送心跳
 */
class HeartbeatManager {
  constructor() {
    this.timer = null
    this.interval = 30000 // 30秒发送一次心跳
    this.isRunning = false
    this.failCount = 0 // 连续失败次数
    this.maxFailCount = 3 // 最大连续失败次数
  }

  /**
   * 启动心跳
   */
  start() {
    if (this.isRunning) {
      return
    }

    console.log('🎯 [心跳管理器] 启动心跳机制')
    this.isRunning = true
    this.failCount = 0

    // 立即发送一次心跳
    this.sendHeartbeat()

    // 设置定时器
    this.timer = setInterval(() => {
      this.sendHeartbeat()
    }, this.interval)

    // 监听页面可见性变化
    this.addVisibilityListener()
    
    // 监听页面卸载事件
    this.addUnloadListener()
  }

  /**
   * 停止心跳
   */
  stop() {
    if (!this.isRunning) {
      return
    }

    console.log('🎯 [心跳管理器] 停止心跳机制')
    this.isRunning = false

    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }

    // 发送下线通知
    this.sendOfflineNotification()
  }

  /**
   * 发送心跳
   */
  sendHeartbeat() {
    // 检查用户是否已登录
    if (!store.state.isLogin || !store.state.token) {
      console.log('🎯 [心跳管理器] 用户未登录，跳过心跳')
      return
    }

    // 检查页面是否可见
    if (document.hidden) {
      console.log('🎯 [心跳管理器] 页面不可见，跳过心跳')
      return
    }

    console.log('🎯 [心跳管理器] 发送心跳')

    // 🎯 获取当前域名
    const currentDomain = window.location.hostname

    request.post('/swx/customer/heartbeat', {
      domain: currentDomain
    }).then(response => {
      if (response.code === 200) {
        this.failCount = 0 // 重置失败计数
        console.log('🎯 [心跳管理器] 心跳发送成功')
      } else {
        this.handleHeartbeatFail('响应错误: ' + response.message)
      }
    }).catch(error => {
      this.handleHeartbeatFail('网络错误: ' + error.message)
    })
  }

  /**
   * 处理心跳失败
   */
  handleHeartbeatFail(reason) {
    this.failCount++
    console.warn(`🎯 [心跳管理器] 心跳失败 (${this.failCount}/${this.maxFailCount}): ${reason}`)

    // 如果连续失败次数过多，可能token已失效
    if (this.failCount >= this.maxFailCount) {
      console.error('🎯 [心跳管理器] 心跳连续失败，可能token已失效')
      // 这里可以触发重新登录逻辑
      // store.dispatch('loginOut')
    }
  }

  /**
   * 发送下线通知
   */
  sendOfflineNotification() {
    if (!store.state.token) {
      return
    }

    try {
      // 使用普通的axios请求，让拦截器自动处理认证
      request.post('/swx/customer/offline', {}).then(() => {
        console.log('🎯 [心跳管理器] 发送下线通知成功')
      }).catch(error => {
        console.warn('🎯 [心跳管理器] 下线通知发送失败:', error)
      })
    } catch (error) {
      console.warn('🎯 [心跳管理器] 下线通知发送异常:', error)
    }
  }

  /**
   * 添加页面可见性监听
   */
  addVisibilityListener() {
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        console.log('🎯 [心跳管理器] 页面隐藏')
      } else {
        console.log('🎯 [心跳管理器] 页面显示，立即发送心跳')
        // 页面重新可见时立即发送心跳
        if (this.isRunning) {
          this.sendHeartbeat()
        }
      }
    })
  }

  /**
   * 添加页面卸载监听
   */
  addUnloadListener() {
    // 页面卸载时发送下线通知
    window.addEventListener('beforeunload', () => {
      this.sendOfflineNotification()
    })

    // 页面隐藏时也发送下线通知（移动端兼容）
    window.addEventListener('pagehide', () => {
      this.sendOfflineNotification()
    })
  }

  /**
   * 重启心跳（用于登录状态变化时）
   */
  restart() {
    this.stop()
    setTimeout(() => {
      this.start()
    }, 1000)
  }
}

// 创建全局实例
const heartbeatManager = new HeartbeatManager()

export default heartbeatManager
